module.exports = __webpack_public_path__ + "static/media/SoLogo.55e6617c.png";